export default {"src":"/_next/static/media/LogotypeFa.613a5148.svg","height":36,"width":55};